const elections = [
  { en: "OFFICIAL BALLOT PAPER", sw: "KARATASI RASMI YA KURA" },
  { en: "Your vote has been received", sw: "Kura yako imepokelewa" },
  {
    en: "All candidates are shown below. Your selection cannot be changed.",
    sw: "Wagombea wote wameonyeshwa hapa chini. Chaguo lako haliwezi kubadilishwa.",
  },
  { en: "You selected this candidate", sw: "Ulimchagua mgombea huyu" },
  { en: "Vote submitted", sw: "Kura iliwasilishwa" },
  { en: "SECRET", sw: "SIRI" },
  { en: "Approved candidate", sw: "Mgombea aliyeidhinishwa" },
  {
    en: "You are not on the voter register.",
    sw: "Haupo kwenye daftari la wapiga kura.",
  },
  {
    en: "Contact the Election Committee if you believe this is an error.",
    sw: "Wasiliana na Kamati ya Uchaguzi ikiwa unaamini hili ni kosa.",
  },
  { en: "Mark one choice", sw: "Weka alama kwenye chaguo moja" },
  { en: "Voting closes", sw: "Upigaji kura unafungwa" },
  {
    en: "Do you approve this candidate?",
    sw: "Je, unamkubali mgombea huyu?",
  },
  { en: "YES", sw: "NDIYO" },
  { en: "NO", sw: "HAPANA" },
  { en: "Approve", sw: "Kubali" },
  { en: "Reject", sw: "Kataa" },
  { en: "Submit my vote", sw: "Wasilisha kura yangu" },
  { en: "OFFICIAL RESULTS", sw: "MATOKEO RASMI" },
  { en: "Published election results", sw: "Matokeo ya uchaguzi yaliyotangazwa" },
  {
    en: "Provisional results — administrators only",
    sw: "Matokeo ya muda — wasimamizi pekee",
  },
  { en: "Total ballots", sw: "Jumla ya kura" },
  { en: "Winner", sw: "Mshindi" },
  { en: "votes", sw: "kura" },
  { en: "Print winner certificate", sw: "Chapisha cheti cha mshindi" },
  { en: "Print TFM results form", sw: "Chapisha fomu ya matokeo ya TFM" },
  { en: "Preview / Save TFM PDF", sw: "Hakiki / Hifadhi TFM PDF" },
  { en: "Download TFM PDF", sw: "Pakua TFM PDF" },
  { en: "Preview PDF", sw: "Hakiki PDF" },
  {
    en: "Your vote cannot be changed after submission.",
    sw: "Kura yako haiwezi kubadilishwa baada ya kuwasilishwa.",
  },
  {
    en: "The selection for this earlier vote cannot be displayed because it was cast before vote receipts were introduced.",
    sw: "Chaguo la kura hii ya zamani haliwezi kuonyeshwa kwa sababu kura ilipigwa kabla ya mfumo wa stakabadhi za kura kuanzishwa.",
  },
];

export default elections;
